/**
 * Country vocabulary shared by the offer and cost center features.
 *
 * Mirrors the server's `Country` enum in server/src/utilities/constant.ts. The two are
 * deliberately kept as separate copies — see docs/adr for why they are not shared.
 */
export const Country = {
  HK: 'hk',
  MO: 'mo',
  OTHERS: 'others',
}

/** Labels as rendered in table cells. */
export const COUNTRY_LABELS = {
  [Country.HK]: 'Hong Kong',
  [Country.MO]: 'Macau',
  [Country.OTHERS]: 'CN / Overseas',
}

/** Falls back to the raw value so unrecognized or empty data renders as-is. */
export const getCountryLabel = (value) => COUNTRY_LABELS[value] ?? value

/** Form dropdown options for an offer's country of installation. */
export const COUNTRY_OPTIONS = [
  { value: Country.HK, label: COUNTRY_LABELS[Country.HK] },
  { value: Country.MO, label: COUNTRY_LABELS[Country.MO] },
  { value: Country.OTHERS, label: COUNTRY_LABELS[Country.OTHERS] },
]

/** Filter dropdowns use a condensed label for the "others" bucket. */
export const COUNTRY_FILTER_OPTIONS = [
  { label: COUNTRY_LABELS[Country.HK], value: Country.HK },
  { label: COUNTRY_LABELS[Country.MO], value: Country.MO },
  { label: 'CN/Overseas', value: Country.OTHERS },
]

/**
 * A cost center sits in Hong Kong or Macau only. `others` is meaningful for an offer's
 * country of installation, not for a cost center's location.
 */
export const COST_CENTER_LOCATION_FILTER_OPTIONS = [
  { label: COUNTRY_LABELS[Country.HK], value: Country.HK },
  { label: COUNTRY_LABELS[Country.MO], value: Country.MO },
]

/** Form dropdown options; the leading blank mirrors the existing optional `type` field. */
export const COST_CENTER_LOCATION_OPTIONS = [{ value: '', label: '' }, ...COST_CENTER_LOCATION_FILTER_OPTIONS]
